// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col[data-v-75c41120] {\n  padding-bottom: 0 !important;\n  padding-top: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
